// extracted by mini-css-extract-plugin
export default {"preApprovedRow":"pre-approved-booking_preApprovedRow__vDLme","deleteBtn":"pre-approved-booking_deleteBtn__XgJMK"};